import http from "../common/services/httpService";
import { AxiosResponse } from "axios";
import queryString from "query-string";

import { ReportLogSearchDto } from "../interfaces/admin/LogReport";
import { stringifyToIsoDate } from "../common/utils/dateTime";

const apiEndpoint = "/reportLog";

const getReportLogs = (model: ReportLogSearchDto): Promise<AxiosResponse<Blob>> => {
  const queryStringModel = queryString.stringify(stringifyToIsoDate(model));
  return http.get<Blob>(`${apiEndpoint}?${queryStringModel}`, {
    responseType: "blob",
  });
};

export default {
  getReportLogs,
};
